/* Build Your Kit v2 (sections/kit-builder.liquid)
   One page, three steps: choose a bag, protect it, organize it. A "Your kit" panel (sidebar on desktop,
   bar + sheet on phones) shows the items, free shipping progress and the total.
   Everything renders from the JSON blob the section prints: live prices and stock, no network calls
   until add to cart (Junip reviews load when a bag's details open). State syncs to the URL so ads,
   shared links and the back button restore the exact kit. */
(function () {
  'use strict';
  var root = document.querySelector('[data-kb]');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-kb-data]').textContent);
  var T = D.t;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').sort().join(' '); };
  var handle = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  var fill = function (str, map) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); };
  var sized = function (src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  var srcset = function (src) { return [240, 360, 540, 720, 1000].map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', '); };
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Prices always show cents ($32.00, like the rest of the store); short drops ".00" for round
  // amounts in sentences ("Free US shipping over $225").
  var fmtCache = {};
  function money(cents, short) {
    var whole = !!short && cents % 100 === 0;
    var k = whole ? 'w' : 'd';
    if (!fmtCache[k]) {
      try {
        fmtCache[k] = new Intl.NumberFormat(D.locale || 'en', { style: 'currency', currency: D.currency || 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
      } catch (e) { fmtCache[k] = { format: function (n) { return '$' + n.toFixed(whole ? 0 : 2); } }; }
    }
    var s = fmtCache[k].format(cents / 100);
    return D.us ? s.replace(/^US\$/, '$') : s;
  }

  // Shopify custom events (for custom pixels in Settings > Customer events), the GTM dataLayer, and
  // Microsoft Clarity custom events so recordings can be filtered by kit builder actions.
  function track(name, detail) {
    detail = detail || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name, kit_builder: detail }); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  /* ---------- Data ---------- */
  var bags = {};
  D.bags.forEach(function (b) {
    b.variants = b.variants.map(function (v) { return { id: v[0], opts: v[1], price: v[2], compare: v[3], avail: v[4], img: v[5] }; });
    b.media = b.media.map(function (m) { return { src: m[0], w: m[1], h: m[2], color: norm(m[3]), large: !!m[4] }; });
    if (b.bundle) b.bundle.variants = b.bundle.variants.map(function (v) { return { id: v[0], opts: v[1], price: v[2], avail: v[3] }; });
    bags[b.key] = b;
  });
  var accKeys = Object.keys(D.acc);
  accKeys.forEach(function (h) {
    var a = D.acc[h];
    a.h = h;
    a.variants = a.variants.map(function (v) { return { id: v[0], opts: v[1], price: v[2], compare: v[3], avail: v[4], img: v[5] }; });
    a.media = (a.media || []).map(function (m) { return { src: m[0], w: m[1], h: m[2] }; });
  });
  var fallback = (D.fallback || []).map(norm);

  function colorOf(b, v) { return b.colorIdx === null ? '' : v.opts[b.colorIdx]; }
  function sizeOf(b, v) { return b.sizeIdx === null ? '' : v.opts[b.sizeIdx]; }
  function sizesOf(b) {
    if (b.sizeIdx === null) return [];
    var out = [];
    b.variants.forEach(function (v) { var s = sizeOf(b, v); if (v.avail && out.indexOf(s) < 0) out.push(s); });
    return out;
  }
  function colorsOf(b, size) {
    var out = [];
    b.variants.forEach(function (v) {
      if (!v.avail) return;
      if (size && norm(sizeOf(b, v)) !== norm(size)) return;
      var c = colorOf(b, v);
      if (out.indexOf(c) < 0) out.push(c);
    });
    return out;
  }
  function bagVariant(b, size, color) {
    return b.variants.filter(function (v) {
      return v.avail && (!size || norm(sizeOf(b, v)) === norm(size)) && (b.colorIdx === null || norm(colorOf(b, v)) === norm(color));
    })[0] || null;
  }
  function photos(b, color, size) {
    var c = norm(color), large = norm(size) === 'large';
    var list = large ? b.media.filter(function (m) { return m.color === c && m.large; }) : [];
    if (!list.length) list = b.media.filter(function (m) { return m.color === c && !m.large; });
    if (!list.length) list = b.media.filter(function (m) { return m.color === c; });
    if (!list.length) list = b.media.filter(function (m) { return !m.color; });
    if (!list.length) { var v = bagVariant(b, size, color); if (v && v.img) list = [{ src: v.img, w: 1000, h: 1000 }]; }
    return list.length ? list : b.media.slice(0, 1);
  }

  // The shopper's color and size on each bag card, kept even before the bag is chosen.
  var pick = {};
  function pickOf(b) {
    if (!pick[b.key]) {
      var sizes = sizesOf(b);
      var size = sizes[0] || '';
      pick[b.key] = { size: size, color: colorsOf(b, size)[0] || '' };
    }
    return pick[b.key];
  }
  function setPick(b, opts) {
    var p = pickOf(b);
    var sizes = sizesOf(b);
    if (opts.size) p.size = sizes.filter(function (s) { return norm(s) === norm(opts.size); })[0] || p.size;
    var cols = colorsOf(b, p.size);
    p.color = cols.filter(function (c) { return norm(c) === norm(opts.color || p.color); })[0] || cols[0] || '';
  }

  /* ---------- State ---------- */
  var st = { bag: null, sel: [], accColor: {} };
  function cur() { return st.bag ? pickOf(st.bag) : { size: '', color: '' }; }

  // Resolve one accessory for the chosen bag: the bag decides the size; color is the shopper's pick,
  // then the bag's color, then the admin fallback order, then the first in-stock color.
  function accVariant(a, pref) {
    var want = null, c = cur();
    if (a.sizeIdx !== null) {
      var m = a.sizeMap || {};
      var key = st.bag ? st.bag.key : '';
      want = (key && (m[key + ':' + handle(c.size)] || m[key])) || m['*'] || null;
    }
    var cands = a.variants.filter(function (v) { return v.avail && (!want || norm(v.opts[a.sizeIdx]) === norm(want)); });
    if (!cands.length) return null;
    if (a.colorIdx === null) return cands[0];
    var order = [];
    if (pref) order.push(norm(pref));
    if (a.match && c.color) order.push(norm(c.color));
    order = order.concat(fallback);
    for (var i = 0; i < order.length; i++) {
      for (var j = 0; j < cands.length; j++) if (norm(cands[j].opts[a.colorIdx]) === order[i]) return cands[j];
    }
    return cands[0];
  }
  function accColors(a) {
    var v0 = accVariant(a);
    if (!v0 || a.colorIdx === null) return [];
    var out = [];
    a.variants.forEach(function (v) {
      if (!v.avail) return;
      if (a.sizeIdx !== null && norm(v.opts[a.sizeIdx]) !== norm(v0.opts[a.sizeIdx])) return;
      var c = v.opts[a.colorIdx];
      if (out.indexOf(c) < 0) out.push(c);
    });
    return out;
  }
  // Add-ons listed for a step: the chosen bag's list (most attached first), or every add-on before a bag is chosen.
  function listFor(step) {
    var keys = st.bag ? st.bag.acc : accKeys;
    return keys.filter(function (h) { return D.acc[h] && D.acc[h].step === step && accVariant(D.acc[h]); });
  }
  function fitsFor(h) { return D.bags.filter(function (b) { return b.acc.indexOf(h) > -1; }).map(function (b) { return b.label; }); }
  function fitsText(h) { var f = fitsFor(h); return f.length === D.bags.length ? T.fitsAll : T.fits + ': ' + f.join(', '); }
  function kitSet() { return st.bag ? st.bag.kit.filter(function (h) { return D.acc[h] && accVariant(D.acc[h]); }) : []; }
  function sameSet(a, b) { return a.length === b.length && a.every(function (x) { return b.indexOf(x) > -1; }); }

  // Price the kit. When the add-ons are exactly the bag's kit and a bundle variant for this color and
  // size costs less, the bundle is what goes in the cart.
  function priceOf(sel) {
    if (!st.bag) return null;
    var c = cur();
    var bv = bagVariant(st.bag, c.size, c.color);
    if (!bv) return null;
    var lines = [{ kind: 'bag', v: bv, label: st.bag.title, img: bv.img || (photos(st.bag, c.color, c.size)[0] || {}).src }];
    sel.forEach(function (h) {
      var a = D.acc[h];
      var v = a && accVariant(a, st.accColor[h]);
      if (v) lines.push({ kind: 'acc', h: h, a: a, v: v, label: a.label, img: v.img || a.img });
    });
    var sum = lines.reduce(function (t, l) { return t + l.v.price; }, 0);
    var bundle = null, b = st.bag.bundle;
    if (b && sel.length && sameSet(sel, st.bag.kit)) {
      bundle = b.variants.filter(function (v) {
        return v.avail && v.price < sum && v.opts.some(function (o) { return norm(o) === norm(c.color); }) &&
          (!c.size || v.opts.some(function (o) { return norm(o) === norm(c.size); }));
      })[0] || null;
    }
    var total = bundle ? bundle.price : sum;
    return { lines: lines, sum: sum, total: total, save: sum - total, bundle: bundle, count: lines.length };
  }

  function chooseBag(key, opts) {
    var b = bags[key];
    if (!b) return;
    opts = opts || {};
    setPick(b, opts);
    var first = !st.bag;
    st.bag = b;
    // Keep add-ons the shopper already picked when they still fit the new bag.
    st.sel = st.sel.filter(function (h) { return b.acc.indexOf(h) > -1 && D.acc[h] && accVariant(D.acc[h]); });
    return first;
  }

  /* ---------- URL ---------- */
  function readUrl() {
    var q = new URLSearchParams(location.search);
    var key = q.get('bag');
    st.bag = null; st.sel = []; st.accColor = {};
    if (!bags[key]) return;
    chooseBag(key, { size: q.get('size'), color: q.get('color') });
    var add = q.get('add'), kit = q.get('kit');
    if (add) {
      var want = add.split(',').map(handle);
      st.sel = st.bag.acc.filter(function (h) { return want.indexOf(h) > -1 && D.acc[h] && accVariant(D.acc[h]); });
    } else if (kit === 'kit' || kit === 'essentials') {
      st.sel = kitSet();
    } else if (kit !== 'bag-only') {
      // No kit in the link: the bag's default (auto = its kit when that reaches free shipping).
      var k = kitSet(), def = st.bag.def;
      if (def === 'auto') { var p = k.length ? priceOf(k) : null; def = p && p.total >= D.threshold ? 'kit' : 'bag-only'; }
      st.sel = def === 'kit' ? k : [];
    }
  }
  function writeUrl() {
    var q = new URLSearchParams(location.search);
    ['bag', 'size', 'color', 'kit', 'add'].forEach(function (k) { q.delete(k); });
    if (st.bag) {
      var c = cur();
      q.set('bag', st.bag.key);
      if (c.size && sizesOf(st.bag).length > 1) q.set('size', handle(c.size));
      if (c.color) q.set('color', handle(c.color));
      var k = kitSet();
      if (!st.sel.length) q.set('kit', 'bag-only');
      else if (k.length && sameSet(st.sel, k)) q.set('kit', 'kit');
      else q.set('add', st.sel.join(','));
    }
    var s = q.toString();
    try { history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
  }

  /* ---------- Pieces ---------- */
  var HEX = {};
  [['triple black', '#1d1d1d'], ['black', '#1d1d1d'], ['pine green', '#828670'], ['moonlit blue', '#475368'], ['blush pink', '#f9dfdf'],
    ['lavender dream', '#d0b6d2'], ['jade green', '#4e6848'], ['boulder tan', '#f1eacf'], ['charcoal gray', '#66615f'], ['misty blue', '#d9f5ff'],
    ['poppy seed', '#6a6a6a'], ['ember orange', '#e88c3c'], ['platinum pink', '#dbb1c4'], ['moonbeam tan', '#dbcdad'], ['desert sand', '#cbaf93'],
    ['niagara mist', '#a0b2c3'], ['burnt brown', '#704339'], ['nimbus gray', '#c9c8c6'], ['poppy red', '#d8333f'], ['lemon yellow', '#f1d415'],
    ['powder teal', '#92c8ce'], ['glacier moon', '#d9dee2']].forEach(function (p) { HEX[norm(p[0])] = p[1]; });
  var ICON = {
    x: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    plus: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.6v.1"/></svg>',
    share: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 15V4M8 8l4-4 4 4M6 12v7h12v-7"/></svg>',
    truck: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7M7 18a1.5 1.5 0 1 0 0-.01M17 18a1.5 1.5 0 1 0 0-.01"/></svg>'
  };
  function img(src, alt, w, h, eager, sizes) {
    if (!src) return '<span class="kb-ph" aria-hidden="true"></span>';
    return '<img src="' + esc(sized(src, 540)) + '" srcset="' + esc(srcset(src)) + '" sizes="' + (sizes || '(min-width: 990px) 22vw, 46vw') + '" width="' + (w || 1000) + '" height="' + (h || 1000) + '" alt="' + esc(alt) + '"' + (eager ? ' fetchpriority="high"' : ' loading="lazy"') + ' decoding="async">';
  }
  function thumb(src, alt) { return src ? '<img src="' + esc(sized(src, 120)) + '" width="56" height="56" alt="' + esc(alt) + '" loading="lazy" decoding="async">' : '<span class="kb-ph" aria-hidden="true"></span>'; }
  function swatches(name, colors, current, labelFor) {
    return colors.map(function (c) {
      return '<label class="kb-sw"><input class="kb-sr" type="radio" name="' + name + '" value="' + esc(c) + '"' + (norm(c) === norm(current) ? ' checked' : '') + ' aria-label="' + esc(labelFor(c)) + '"><span class="kb-sw__dot" style="--sw:' + esc(HEX[norm(c)] || '#d6d1ca') + '"></span></label>';
    }).join('');
  }
  function stars(r, n) {
    return r && n ? '<p class="kb-rate"><span aria-hidden="true">★</span> ' + esc(Number(r).toFixed(1)) + '<span class="kb-sr"> ' + esc(T.outOf5) + '</span> <span class="kb-muted">(' + Number(n).toLocaleString('en-US') + '<span class="kb-sr"> ' + esc(T.reviewsWord) + '</span>)</span></p>' : '';
  }

  /* ---------- Bag cards ---------- */
  var filter = '';
  function bagCard(b, i) {
    var p = pickOf(b);
    var on = st.bag === b;
    var v = bagVariant(b, p.size, p.color);
    var ph = photos(b, p.color, p.size)[0] || {};
    var sizes = sizesOf(b), cols = b.colorIdx === null ? [] : colorsOf(b, p.size);
    var alt = b.title + (norm(p.size) === 'large' ? ' ' + T.large : '') + (p.color ? ' ' + T.inColor + ' ' + p.color : '');
    var btn = on ? T.inKit : (st.bag ? T.swapTo : T.addToKit);
    return '<li class="kb-card' + (on ? ' is-on' : '') + '" data-kb-bag="' + b.key + '"' + (filter && b.group !== filter ? ' hidden' : '') + '>' +
      '<div class="kb-card__media">' + img(ph.src, alt, ph.w, ph.h, i < 2) +
        '<button type="button" class="kb-info" data-kb-info="bag:' + b.key + '" aria-label="' + esc(fill(T.details, { item: b.title })) + '" aria-haspopup="dialog">' + ICON.info + '</button></div>' +
      '<div class="kb-card__body">' +
        '<h3 class="kb-card__name">' + esc(b.title) + '</h3>' + stars(b.rating, b.count) +
        '<p class="kb-card__price">' + (v ? money(v.price) : '') + '</p>' +
        (sizes.length > 1 ? '<fieldset class="kb-mini"><legend class="kb-sr">' + esc(T.size) + '</legend><div class="kb-seg">' + sizes.map(function (s) {
          return '<label class="kb-segbtn"><input class="kb-sr" type="radio" name="kb-size-' + b.key + '" value="' + esc(s) + '"' + (norm(s) === norm(p.size) ? ' checked' : '') + '><span>' + esc(s) + '</span></label>';
        }).join('') + '</div>' + (b.sizeSheet ? '<button type="button" class="kb-link" data-kb-which="' + b.key + '" aria-haspopup="dialog">' + esc(T.whichSize) + '</button>' : '') + '</fieldset>' : '') +
        (cols.length ? '<fieldset class="kb-mini"><legend class="kb-sr">' + esc(T.colorWord) + '</legend><p class="kb-card__color">' + esc(p.color) + '</p><div class="kb-sws">' +
          swatches('kb-color-' + b.key, cols, p.color, function (c) { return b.label + ', ' + c; }) + '</div></fieldset>' : '') +
        '<div class="kb-card__foot"><span class="kb-stock">' + esc(T.inStock) + '</span>' +
          '<button type="button" class="kb-add' + (on ? ' is-on' : '') + '" data-kb-pick-bag="' + b.key + '" aria-pressed="' + on + '">' + (on ? ICON.check : ICON.plus) + '<span>' + esc(btn) + '</span></button></div>' +
      '</div></li>';
  }
  function renderBags() {
    $('[data-kb-cards="bags"]').innerHTML = D.bags.map(bagCard).join('');
  }

  /* ---------- Add-on cards ---------- */
  function accCard(h) {
    var a = D.acc[h];
    var v = accVariant(a, st.accColor[h]);
    var on = st.sel.indexOf(h) > -1;
    var cols = st.bag ? accColors(a) : [];
    var curColor = v && a.colorIdx !== null ? v.opts[a.colorIdx] : '';
    var badge = st.bag && st.bag.kit.indexOf(h) > -1 && T.pairs ? fill(T.pairs, { bag: st.bag.label }) : '';
    var src = (v && v.img) || a.img;
    return '<li class="kb-card kb-card--acc' + (on ? ' is-on' : '') + '" data-kb-acc="' + h + '">' +
      '<div class="kb-card__media">' + img(src, a.title + (curColor ? ' ' + T.inColor + ' ' + curColor : ''), 1000, 1000, false) +
        (badge ? '<span class="kb-badge">' + esc(badge) + '</span>' : '') +
        '<button type="button" class="kb-info" data-kb-info="acc:' + h + '" aria-label="' + esc(fill(T.details, { item: a.title })) + '" aria-haspopup="dialog">' + ICON.info + '</button></div>' +
      '<div class="kb-card__body">' +
        '<h3 class="kb-card__name">' + esc(a.label) + '</h3>' +
        (a.holds ? '<p class="kb-card__holds">' + esc(a.holds) + '</p>' : '') +
        (a.solution ? '<p class="kb-card__line">' + esc(a.solution) + '</p>' : '') +
        (!st.bag ? '<p class="kb-card__fits">' + esc(fitsText(h)) + '</p>' : '') +
        '<p class="kb-card__price">' + (v ? money(v.price) : '') + '</p>' +
        (cols.length > 1 ? '<fieldset class="kb-mini"><legend class="kb-sr">' + esc(a.label + ' ' + T.colorWord) + '</legend><p class="kb-card__color">' + esc(curColor) + '</p><div class="kb-sws">' +
          swatches('kb-acc-' + h, cols, curColor, function (c) { return a.label + ', ' + c; }) + '</div></fieldset>' : '') +
        '<div class="kb-card__foot"><span class="kb-stock">' + esc(T.inStock) + '</span>' +
          '<button type="button" class="kb-add' + (on ? ' is-on' : '') + '" data-kb-toggle="' + h + '" aria-pressed="' + on + '"' + (st.bag ? '' : ' disabled') + '>' + (on ? ICON.check : ICON.plus) + '<span>' + esc(on ? T.inKit : T.addToKit) + '</span></button></div>' +
      '</div></li>';
  }
  function renderAccs() {
    ['protect', 'organize'].forEach(function (step) {
      var ul = $('[data-kb-cards="' + step + '"]');
      ul.innerHTML = listFor(step).map(accCard).join('');
      ul.classList.toggle('is-locked', !st.bag);
      ul.parentNode.querySelector('[data-kb-locked]').hidden = !!st.bag;
    });
  }

  /* ---------- Kit panel ---------- */
  var addedSig = null;
  function sig() { var c = cur(); return [st.bag && st.bag.key, c.size, c.color, st.sel.join(','), JSON.stringify(st.accColor)].join('|'); }
  function cartSub() { return D.cartSub || 0; }
  var shipUnlocked = false;

  function renderKit() {
    var p = priceOf(st.sel);
    var count = p ? p.count : 0;
    var total = p ? p.total : 0;
    // Items already in the cart count toward free shipping, same as checkout. A kit that was just
    // added is already in the cart, so it is not counted twice.
    var inCart = cartSub() + (p && sig() !== addedSig ? total : 0);
    var left = D.threshold - inCart;
    var ship = left > 0 ? fill(T.progress, { amount: money(left) }) : T.progressDone;
    if (!p && left > 0 && T.shipLine) ship = fill(T.shipLine, { threshold: money(D.threshold, true) }); // empty kit: state the offer instead of a countdown
    var ratio = Math.min(1, inCart / D.threshold);
    if (left <= 0 && !shipUnlocked) { shipUnlocked = true; if (ready && p) track('free_shipping_unlocked', { bag: st.bag.key, value: total / 100 }); }
    else if (left > 0) shipUnlocked = false;

    var c = cur();
    var items = p ? p.lines.map(function (l) {
      var sub = l.kind === 'bag' ? [c.color, sizesOf(st.bag).length > 1 ? c.size : ''].filter(Boolean).join(' / ') : (l.a.colorIdx !== null ? l.v.opts[l.a.colorIdx] : (l.a.sizeIdx !== null ? l.v.opts[l.a.sizeIdx] : ''));
      return '<li class="kb-kit__item">' + thumb(l.img, l.label + (sub ? ', ' + sub : '')) +
        '<div class="kb-kit__info"><p class="kb-kit__name">' + esc(l.label) + '</p>' + (sub ? '<p class="kb-kit__sub">' + esc(sub) + '</p>' : '') + '</div>' +
        '<p class="kb-kit__price">' + money(l.v.price) + '</p>' +
        '<button type="button" class="kb-x" data-kb-remove="' + (l.kind === 'bag' ? '@bag' : l.h) + '" aria-label="' + esc(fill(T.remove, { item: l.label })) + '">' + ICON.x + '</button></li>';
    }).join('') : '';
    var empty = '<div class="kb-kit__empty"><span class="kb-ph" aria-hidden="true"></span><div><p class="kb-kit__name">' + esc(T.emptyTitle) + '</p><p class="kb-kit__sub">' + esc(T.emptyText) + '</p></div></div>';
    var shipBox = D.us ? '<div class="kb-ship' + (left <= 0 ? ' is-done' : '') + '"><p class="kb-ship__top">' + ICON.truck + '<span class="kb-ship__label">' + esc(T.freeShip) + '</span><span class="kb-ship__amt">' + money(D.threshold, true) + '</span></p>' +
      '<p class="kb-ship__text">' + esc(ship) + '</p><div class="kb-meter" aria-hidden="true"><span style="transform:scaleX(' + ratio + ')"></span></div>' +
      (deliveryText ? '<p class="kb-ship__eta">' + esc(deliveryText) + '</p>' : '') + '</div>' : '';
    var rows = '<dl class="kb-sum"><div><dt>' + esc(T.subtotal) + '</dt><dd>' + money(p ? p.sum : 0) + '</dd></div>' +
      (p && p.save > 0 ? '<div class="kb-sum__save"><dt>' + esc(T.bundleSave) + '</dt><dd>-' + money(p.save) + '</dd></div>' : '') +
      (D.us && p ? '<div><dt>' + esc(T.shipping) + '</dt><dd>' + esc(inCart >= D.threshold ? T.free : T.shipCalc) + '</dd></div>' : '') +
      '</dl><p class="kb-total"><span>' + esc(T.total) + '</span><strong>' + money(total) + '</strong></p>';
    var cta = '<button type="button" class="kb-cta" data-kb-cta' + (p ? '' : ' disabled') + '><span data-kb-cta-label>' + esc(p ? T.cta : T.ctaEmpty) + '</span></button><p class="kb-err" data-kb-err role="alert"></p>';

    $$('[data-kb-kit]').forEach(function (el) {
      var inSheet = el.hasAttribute('data-kb-in-sheet');
      el.innerHTML = '<div class="kb-kit__head"><h2 class="kb-kit__title">' + esc(T.yourKit) + ' <span class="kb-count">' + count + '</span></h2>' +
        '<button type="button" class="kb-x" data-kb-share aria-label="' + esc(T.share) + '">' + ICON.share + '</button>' +
        (inSheet ? '<button type="button" class="kb-x" data-kb-close aria-label="' + esc(T.close) + '">' + ICON.x + '</button>' : '') + '</div>' +
        (items ? '<ul class="kb-kit__items">' + items + '</ul>' : empty) + shipBox + rows + cta;
    });
    // Phone bar
    $('[data-kb-count]').textContent = count;
    $('[data-kb-bar-total]').textContent = money(total);
    var bp = $('[data-kb-bar-prog]'); if (bp) bp.textContent = ship;
    var bm = $('[data-kb-meter]'); if (bm) bm.style.transform = 'scaleX(' + ratio + ')';
    var bc = $('.kb-bar [data-kb-cta]');
    bc.disabled = !p;
    $('.kb-bar [data-kb-cta-label]').textContent = p ? T.cta : T.ctaEmpty;
    return { p: p, ship: ship };
  }

  /* ---------- Render ---------- */
  var ready = false;
  function renderAll(announce) {
    var focusKey = focusId(document.activeElement);
    renderBags();
    renderAccs();
    var k = renderKit();
    writeUrl();
    if (detailsOpen) renderDetails();
    restoreFocus(focusKey);
    if (announce && k.p) live(money(k.p.total) + (k.p.save > 0 ? '. ' + T.bundleSave + ' ' + money(k.p.save) : '') + '. ' + k.ship);
  }
  // Re-rendering replaces the controls, so keep keyboard and screen reader focus on the same control.
  function focusId(el) {
    if (!el || !root.contains(el)) return null;
    var attrs = ['data-kb-pick-bag', 'data-kb-toggle', 'data-kb-info', 'data-kb-which'];
    for (var i = 0; i < attrs.length; i++) if (el.hasAttribute(attrs[i])) return '[' + attrs[i] + '="' + el.getAttribute(attrs[i]) + '"]';
    if (el.name && el.type === 'radio') return 'input[name="' + el.name + '"][value="' + String(el.value).replace(/"/g, '\\"') + '"]';
    return null;
  }
  function restoreFocus(sel) {
    if (!sel) return;
    var el = (detailsOpen && $(sel, $('[data-kb-sheet="details"]'))) || $(sel);
    if (el) el.focus({ preventScroll: true });
  }

  var liveTimer;
  function live(text) {
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () { $('[data-kb-live]').textContent = text; }, 250);
  }

  /* ---------- Details sheet ---------- */
  var detailsOpen = null;
  function renderDetails() {
    var parts = detailsOpen.split(':'), type = parts[0], key = parts[1];
    var html = '';
    if (type === 'bag') {
      var b = bags[key], pk = pickOf(b), v = bagVariant(b, pk.size, pk.color), list = photos(b, pk.color, pk.size).slice(0, 6);
      var on = st.bag === b;
      var altBase = b.title + (norm(pk.size) === 'large' ? ' ' + T.large : '') + (pk.color ? ' ' + T.inColor + ' ' + pk.color : '');
      html = gallery(list, altBase) +
        '<h2 class="kb-h3" id="kb-det-h">' + esc(b.title) + '</h2>' + stars(b.rating, b.count) +
        '<p class="kb-det__price">' + (v ? money(v.price) : '') + '</p>' +
        (b.colorIdx !== null ? '<fieldset class="kb-mini"><legend class="kb-sr">' + esc(T.colorWord) + '</legend><p class="kb-card__color">' + esc(pk.color) + '</p><div class="kb-sws">' +
          swatches('kb-color-' + b.key, colorsOf(b, pk.size), pk.color, function (c) { return b.label + ', ' + c; }) + '</div></fieldset>' : '') +
        (b.desc ? '<p class="kb-det__desc">' + esc(b.desc) + '</p>' : '') +
        '<button type="button" class="kb-add kb-add--wide' + (on ? ' is-on' : '') + '" data-kb-pick-bag="' + b.key + '" aria-pressed="' + on + '">' + (on ? ICON.check : ICON.plus) + '<span>' + esc(on ? T.inKit : (st.bag ? T.swapTo : T.addToKit)) + '</span></button>' +
        '<a class="kb-link kb-det__more" href="' + esc(b.url) + '">' + esc(T.viewFull) + '</a>' +
        '<div class="kb-det__reviews" data-kb-reviews hidden><h3 class="kb-h3">' + esc(T.reviewsHeading) + '</h3><ul class="kb-reviews__list" data-kb-reviews-list></ul></div>';
    } else {
      var a = D.acc[key], av = accVariant(a, st.accColor[key]), aon = st.sel.indexOf(key) > -1;
      var aList = a.media.length ? a.media : [{ src: (av && av.img) || a.img, w: 1000, h: 1000 }];
      if (av && av.img) aList = [{ src: av.img, w: 1000, h: 1000 }].concat(aList.filter(function (m) { return m.src.split('?')[0] !== av.img.split('?')[0]; }));
      html = gallery(aList.slice(0, 6), a.title) +
        '<h2 class="kb-h3" id="kb-det-h">' + esc(a.title) + '</h2>' + stars(a.rating, a.count) +
        '<p class="kb-det__price">' + (av ? money(av.price) : '') + '</p>' +
        (a.holds ? '<p class="kb-det__holds">' + esc(a.holds) + '</p>' : '') +
        (a.problem ? '<p class="kb-det__problem">' + esc(a.problem) + '</p>' : '') +
        (a.solution ? '<p class="kb-det__solution">' + esc(a.solution) + '</p>' : '') +
        (a.desc ? '<p class="kb-det__desc">' + esc(a.desc) + '</p>' : '') +
        '<p class="kb-det__fits">' + esc(fitsText(key)) + '</p>' +
        (st.bag ? '<button type="button" class="kb-add kb-add--wide' + (aon ? ' is-on' : '') + '" data-kb-toggle="' + key + '" aria-pressed="' + aon + '">' + (aon ? ICON.check : ICON.plus) + '<span>' + esc(aon ? T.inKit : T.addToKit) + '</span></button>' : '<p class="kb-locked">' + esc(T.locked) + '</p>') +
        '<a class="kb-link kb-det__more" href="' + esc(a.url) + '">' + esc(T.viewFull) + '</a>';
    }
    $('[data-kb-details]').innerHTML = html;
    if (type === 'bag') loadReviews(bags[key]);
  }
  function gallery(list, altBase) {
    var n = list.length;
    return '<ul class="kb-gal" tabindex="0" aria-label="' + esc(altBase) + '">' + list.map(function (m, i) {
      return '<li>' + img(m.src, altBase + ', ' + fill(T.photoOf, { i: i + 1, n: n }), m.w, m.h, i === 0, '(min-width: 990px) 560px, 100vw') + '</li>';
    }).join('') + '</ul>';
  }

  /* ---------- Reviews (Junip, when a bag's details open) ---------- */
  var reviewCache = {};
  function loadReviews(b) {
    var keyEl = document.querySelector('[data-store-key]');
    var key = keyEl && keyEl.getAttribute('data-store-key');
    var done = function (list) {
      if (list.length < 3) list = list.concat(b.reviews.map(function (r) { return { name: r.a, rating: r.r, body: r.b, detail: r.d }; })).slice(0, 3);
      if (detailsOpen === 'bag:' + b.key) renderReviews(list.slice(0, 3));
    };
    if (reviewCache[b.pid]) return done(reviewCache[b.pid]);
    if (!key) return done([]);
    fetch('https://api.juniphq.com/v1/product_reviews?filter[product_remote_ids]=' + b.pid + '&page[size]=100&include=customer', { headers: { 'Junip-Store-Key': key } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        // Order: reviews hand-picked in the bag's metaobject, then Junip pinned or featured 5 star
        // reviews, then other English 5 star reviews of a sentence or two. Never invented reviews.
        var all = j.product_reviews || [];
        var len = function (r) { return (r.body || '').replace(/\s+/g, ' ').trim().length; };
        var english = function (r) { return /\b(the|and|this|my|it|for|love|with|to|of|so|great|was|very|bag|i)\b/i.test(r.body || ''); };
        var good = function (r) { return r.rating === 5 && len(r) >= 40 && len(r) <= 320 && english(r); };
        var ids = (b.reviewIds || []).map(String);
        var picked = ids.map(function (id) { return all.filter(function (r) { return String(r.id) === id; })[0]; }).filter(Boolean);
        all.filter(function (r) { return (r.pinned || r.featured) && good(r); })
          .concat(all.filter(good))
          .forEach(function (r) { if (picked.length < 3 && picked.indexOf(r) < 0) picked.push(r); });
        var list = picked.slice(0, 3).map(function (r) {
          var c = r.customer || {};
          return { name: (r.respondent_display_name || ((c.first_name || '') + (c.last_name ? ' ' + c.last_name.charAt(0) + '.' : ''))).trim(), rating: r.rating, body: r.body.replace(/\s+/g, ' ').trim(), detail: r.target_title || '' };
        });
        reviewCache[b.pid] = list;
        done(list);
      })
      .catch(function () { done([]); });
  }
  function renderReviews(list) {
    var wrap = $('[data-kb-reviews]', $('[data-kb-sheet="details"]'));
    if (!wrap) return;
    wrap.hidden = !list.length;
    $('[data-kb-reviews-list]', wrap).innerHTML = list.map(function (r) {
      var n = Math.max(1, Math.min(5, Number(r.rating) || 5));
      return '<li class="kb-review"><p class="kb-stars" role="img" aria-label="' + esc(fill(T.starsLabel, { n: n })) + '">' + '★★★★★'.slice(0, n) + '</p><p class="kb-review__body">' + esc(r.body) + '</p><p class="kb-review__by">' + esc(r.name) + (r.detail ? ' <span class="kb-muted">' + esc(r.detail) + '</span>' : '') + '</p></li>';
    }).join('');
  }

  /* ---------- Sheets ---------- */
  var lastTrigger = null;
  function openSheet(name, trigger) {
    var d = $('[data-kb-sheet="' + name + '"]');
    lastTrigger = trigger || document.activeElement;
    lastTriggerKey = focusId(lastTrigger);
    if (d.showModal) d.showModal(); else { d.setAttribute('open', ''); d.classList.add('kb-nomodal'); }
    document.documentElement.classList.add('kb-locked');
    var panel = d.querySelector('.kb-sheet__panel');
    panel.scrollTop = 0;
    var f = d.querySelector('[data-kb-close], button, [href], input');
    if (f) f.focus();
  }
  function closeSheet(d) {
    if (!d || !d.hasAttribute('open')) return;
    if (d.close) d.close(); else { d.removeAttribute('open'); d.dispatchEvent(new Event('close')); }
  }
  $$('.kb-sheet').forEach(function (d) {
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('kb-locked');
      d.querySelector('.kb-sheet__panel').style.transform = '';
      if (d.getAttribute('data-kb-sheet') === 'details') detailsOpen = null;
      if (lastTrigger && lastTrigger.isConnected && lastTrigger.focus) lastTrigger.focus();
      else if (lastTrigger) restoreFocus(lastTriggerKey);
    });
    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-kb-close]')) closeSheet(d);
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(d); return; }
      if (e.key !== 'Tab' || d.showModal) return; // native modal dialogs already trap focus
      var f = $$('button, [href], input', d).filter(function (x) { return !x.disabled && x.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    // Swipe down to close: drag from the grab bar or the sheet header.
    var panel = d.querySelector('.kb-sheet__panel');
    var y0 = null, dy = 0;
    panel.addEventListener('touchstart', function (e) {
      y0 = e.target.closest('[data-kb-grab], .kb-sheet__head, .kb-kit__head') ? e.touches[0].clientY : null;
      dy = 0;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (y0 === null) return;
      y0 = null;
      if (dy > 80) closeSheet(d); else panel.style.transform = '';
    });
  });
  var lastTriggerKey = null;

  /* ---------- Cart ---------- */
  // Subtotal of what is already in the cart (rendered by Liquid, then kept current from UpCart's
  // public cart events), so the free shipping line matches checkout.
  function onCart(e) {
    var c = e && e.detail && (e.detail.cart || e.detail);
    // UpCart's public event sends { items, currency, total, totalBeforeDiscounts } in cents.
    var sub = c && [c.total, c.items_subtotal_price, c.total_price].filter(function (x) { return typeof x === 'number'; })[0];
    if (typeof sub !== 'number' || sub === D.cartSub) return;
    D.cartSub = sub;
    renderKit();
  }
  ['aftersell-upcart:public-events:cart-loaded', 'aftersell-upcart:public-events:cart-updated'].forEach(function (n) { window.addEventListener(n, onCart); });

  // One /cart/add.js call with every line. When the bundle is cheaper it replaces the bag and the
  // kit items. The hidden _kit property tags kit builder lines for reporting.
  var busy = false;
  function addToCart(btn) {
    if (busy) return;
    var p = priceOf(st.sel);
    if (!p) return;
    var props = { _kit: st.bag.key };
    var items = p.bundle
      ? [{ id: p.bundle.id, quantity: 1, properties: props }]
      : p.lines.map(function (l) { return { id: l.v.id, quantity: 1, properties: props }; }).reverse(); // newest line shows first, so the bag goes last
    var labels = $$('[data-kb-cta-label]');
    busy = true;
    $$('[data-kb-err]').forEach(function (e) { e.textContent = ''; });
    $$('[data-kb-cta]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.classList.add('is-busy'); });
    labels.forEach(function (l) { l.textContent = T.adding; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || '');
        return j;
      });
    }).then(function () {
      track('kit_add_to_cart', { bag: st.bag.key, value: p.total / 100, currency: D.currency, item_count: p.count, bundle: !!p.bundle, items: st.sel.join(',') });
      live(T.addedLive);
      D.cartSub = cartSub() + p.total;
      addedSig = sig();
      closeSheet($('[data-kb-sheet="kit"]'));
      return openCart();
    }).catch(function (e) {
      var msg = [T.error, e && e.message].filter(Boolean).join(' ');
      $$('[data-kb-err]').forEach(function (el) { el.textContent = msg; });
    }).then(function () {
      busy = false;
      renderKit();
      $$('[data-kb-cta]').forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); });
    });
  }
  function openCart() {
    var refresh = typeof window.upcartRefreshCart === 'function' ? window.upcartRefreshCart() : null;
    if (typeof window.upcartOpenCart !== 'function') { window.location.href = '/cart'; return; }
    return Promise.resolve(refresh).catch(function () {}).then(function () { window.upcartOpenCart(); });
  }

  function share(btn) {
    var url = location.href;
    track('kit_shared', { bag: st.bag ? st.bag.key : '' });
    if (navigator.share) { navigator.share({ title: document.title, url: url }).catch(function () {}); return; }
    var ok = function () { live(T.copied); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(ok, function () {});
  }

  /* ---------- Delivery estimate ---------- */
  var deliveryText = '';
  function computeDelivery() {
    if (!T.delivery) return;
    var m = /^([+-])(\d\d)(\d\d)$/.exec(D.tz || '');
    var off = m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : 0;
    var now = new Date(Date.now() + off * 60000); // store-local time, read with UTC getters
    var d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var wk = function (x) { var g = x.getUTCDay(); return g > 0 && g < 6; };
    var next = function (x) { x = new Date(x.getTime() + 864e5); while (!wk(x)) x = new Date(x.getTime() + 864e5); return x; };
    var ship = wk(d) && now.getUTCHours() < D.cutoff ? d : next(d);
    var add = function (x, n) { for (var i = 0; i < n; i++) x = next(x); return x; };
    var f = new Intl.DateTimeFormat(D.locale || 'en', { month: 'short', day: 'numeric', timeZone: 'UTC' });
    deliveryText = fill(T.delivery, { range: f.format(add(ship, D.tmin)) + ' ' + T.dateJoin + ' ' + f.format(add(ship, D.tmax)) });
    var el = $('[data-kb-delivery]');
    if (el) { $('[data-kb-delivery-text]').textContent = deliveryText; el.hidden = false; }
  }

  /* ---------- Events ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target, n = t.name || '';
    if (n.indexOf('kb-color-') === 0 || n.indexOf('kb-size-') === 0) {
      var isColor = n.indexOf('kb-color-') === 0;
      var b = bags[n.slice(isColor ? 9 : 8)];
      setPick(b, isColor ? { color: t.value } : { size: t.value });
      if (st.bag === b) st.sel = st.sel.filter(function (h) { return accVariant(D.acc[h]); });
      renderAll(st.bag === b);
      track(isColor ? 'color_selected' : 'size_selected', { bag: b.key, value: handle(t.value), in_kit: st.bag === b });
    } else if (n.indexOf('kb-acc-') === 0) {
      st.accColor[n.slice(7)] = t.value;
      renderAll(true);
      track('color_selected', { addon: n.slice(7), value: handle(t.value) });
    }
  });
  root.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-kb-pick-bag]'))) {
      var key = el.getAttribute('data-kb-pick-bag');
      if (st.bag && st.bag.key === key) return;
      var first = chooseBag(key);
      renderAll(true);
      track('bag_selected', { bag: key, first: !!first });
      if (first && !detailsOpen) {
        var s2 = $('#kb-step-2');
        if (s2) s2.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }
    if ((el = e.target.closest('[data-kb-toggle]'))) {
      var h = el.getAttribute('data-kb-toggle');
      if (!st.bag) return;
      var i = st.sel.indexOf(h);
      if (i > -1) st.sel.splice(i, 1); else st.sel.push(h);
      st.sel = st.bag.acc.filter(function (x) { return st.sel.indexOf(x) > -1; });
      renderAll(true);
      track('addon_toggled', { bag: st.bag.key, addon: h, on: i < 0 });
      return;
    }
    if ((el = e.target.closest('[data-kb-remove]'))) {
      var rh = el.getAttribute('data-kb-remove');
      if (rh === '@bag') { st.bag = null; st.sel = []; st.accColor = {}; }
      else st.sel = st.sel.filter(function (x) { return x !== rh; });
      renderAll(true);
      var next = $('[data-kb-kit] [data-kb-remove], [data-kb-kit] [data-kb-share]');
      if (next) next.focus();
      track('addon_toggled', { bag: st.bag ? st.bag.key : '', addon: rh, on: false });
      return;
    }
    if ((el = e.target.closest('[data-kb-info]'))) {
      detailsOpen = el.getAttribute('data-kb-info');
      renderDetails();
      openSheet('details', el);
      track('details_opened', { item: detailsOpen });
      return;
    }
    if ((el = e.target.closest('[data-kb-which]'))) {
      var wb = bags[el.getAttribute('data-kb-which')];
      $('[data-kb-size-h]').textContent = wb.sizeSheet || '';
      $('[data-kb-size-body]').textContent = wb.sizeSheetBody || '';
      openSheet('size', el);
      return;
    }
    if ((el = e.target.closest('[data-kb-open-kit]'))) { renderKit(); openSheet('kit', el); track('kit_opened', {}); return; }
    if ((el = e.target.closest('[data-kb-share]'))) { share(el); return; }
    if ((el = e.target.closest('[data-kb-cta]'))) { addToCart(el); return; }
    if ((el = e.target.closest('[data-kb-filter]'))) {
      filter = el.getAttribute('data-kb-filter');
      $$('[data-kb-filter]').forEach(function (b) { var on = b === el; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
      $$('[data-kb-bag]').forEach(function (li) { li.hidden = !!filter && bags[li.getAttribute('data-kb-bag')].group !== filter; });
    }
  });

  // Step tabs follow the scroll position.
  if ('IntersectionObserver' in window) {
    var tabs = $$('[data-kb-tab]');
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        var n = x.target.getAttribute('data-kb-step');
        tabs.forEach(function (t) { var on = t.getAttribute('data-kb-tab') === n; t.classList.toggle('is-on', on); if (on) t.setAttribute('aria-current', 'step'); else t.removeAttribute('aria-current'); });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    $$('[data-kb-step]').forEach(function (s) { io.observe(s); });
  }

  window.addEventListener('popstate', function () { readUrl(); renderAll(); });

  // The theme header is sticky (and can hide on scroll), so pin the step tabs just under its
  // current bottom edge; steps scroll to below both.
  var hdrs = $$('.shopify-section-group-header-group', document).filter(function (el) { return /sticky|fixed/.test(getComputedStyle(el).position); });
  var hdrRaf;
  function placeTabs() {
    var b = 0;
    hdrs.forEach(function (el) { b = Math.max(b, Math.round(el.getBoundingClientRect().bottom)); });
    root.style.setProperty('--kb-tabs-top', b + 'px');
  }
  if (hdrs.length) {
    placeTabs();
    window.addEventListener('scroll', function () { cancelAnimationFrame(hdrRaf); hdrRaf = requestAnimationFrame(placeTabs); }, { passive: true });
    window.addEventListener('resize', placeTabs);
  }

  /* ---------- Start ---------- */
  computeDelivery();
  readUrl();
  renderAll();
  var th = $('[data-kb-threshold]');
  if (th) th.textContent = money(D.threshold, true);
  ready = true;
  root.classList.add('is-ready');
  try { if (typeof window.clarity === 'function' && st.bag) window.clarity('set', 'kit_bag', st.bag.key); } catch (e) {}
  track('kit_builder_view', { bag: st.bag ? st.bag.key : '', size: handle(cur().size), color: handle(cur().color), kit: st.sel.length ? st.sel.join(',') : 'bag-only' });
})();
